import { render } from "./MultipleChoiceOption.vue?vue&type=template&id=96f60630&scoped=true"
import script from "./MultipleChoiceOption.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceOption.vue?vue&type=script&lang=js"

import "./MultipleChoiceOption.vue?vue&type=style&index=0&id=96f60630&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f60630"]])

export default __exports__